import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetErpIntegrationsApi } from './use-get-erp-integrations-api';

const endpoint = 'ums/v1/erp/integrations';
export const createErpIntegrationEndpointIdentifier = endpoint;

interface BodyType {
  restaurantId: number;
  supplierId: number;
  supplierType: string;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCreateErpIntegrationApi(options?: Options): ReturnType {
  const { refetch: refetchErpIntegrationsApi } = useGetErpIntegrationsApi({ enabled: false });

  const toast = useCustomToast();

  const mutationFn = async ({ body }: TVariables) => {
    try {
      const { data } = await http.post(endpoint, body);

      // Refetch erp integrations list
      refetchErpIntegrationsApi();

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
